import React, { useEffect, useState } from "react"
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserTenantConnections } from "../app/actions";


const initalValue = {
    ShortName: "", 
    FullName: "", 
    Active: "Yes", 
    Type: "Prospect",
    Live: "No", 
    BusinessStatus: "Green",
    BusinessComment: "",
    PrimaryContact: "",
    SecondaryContact: ""
};

const AddEditTenantModal = ({editTenant = null, show, onHide, onSave}) => {
    const creatingTenant = useSelector(store => store.app.creatingTenant)
    const updatingTenant = useSelector(store => store.app.updatingTenant)
    const [tenant, setTenant] = useState(initalValue)
    const userTenantConnections = useSelector(store => store.app.userTenantConnections)
    const dispatch = useDispatch()

    useEffect(()=>{
        if(editTenant) {
            dispatch(fetchUserTenantConnections(1, {TenantID: editTenant.id}))
        }
    }, [])

    useEffect(()=>{
        if(editTenant) {
            setTenant({
                id: editTenant.id,
                ShortName: editTenant.ShortName || initalValue.ShortName,
                FullName: editTenant.FullName || initalValue.FullName,
                Active: editTenant.Active || initalValue.Active,
                Type: editTenant.Type || initalValue.Type,
                Live: editTenant.Live || initalValue.Live,
                BusinessStatus: editTenant.BusinessStatus || initalValue.BusinessStatus,
                BusinessComment: editTenant.BusinessComment || initalValue.BusinessComment,
                PrimaryContact: editTenant.PrimaryContact || initalValue.PrimaryContact,
                SecondaryContact: editTenant.SecondaryContact || initalValue.SecondaryContact
            })
        } else {
            setTenant(initalValue)
        }
    }, [show])

    const handleChange = (e) => {
        setTenant({
            ...tenant,
            [e.target.name]: e.target.value
        })
    }

    const handleSave = () => {
        onSave(tenant)
    }

    const handleRadioButtonChange = e => {
        setTenant({
            ...tenant,
            [e.target.name]: e.target.value
        })
    }


    return <Modal show={show} onHide={onHide}>
        <Modal.Header>
            <Modal.Title>
                Deploy tenant
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        <Form>
            <Form.Group>
                <Form.Label>Full name</Form.Label>
                <Form.Control type="text" placeholder="Enter full name" name="FullName" value={tenant.FullName} onChange={handleChange} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Short name</Form.Label>
                <Form.Control type="text" placeholder="Enter short name" name="ShortName" value={tenant.ShortName} onChange={handleChange} />
            </Form.Group>
            <Form.Group>
                <div><Form.Label>Active</Form.Label></div>
                <Form.Check
                    inline
                    id="activeRadioOption"
                    type="radio"
                    name="Active"
                    label="Yes"
                    value="Yes"
                    checked={tenant.Active === "Yes"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    inline
                    id="userRadioOption"
                    type="radio"
                    name="Active"
                    label="No"
                    value="No"
                    checked={tenant.Active === "No"}
                    onChange={handleRadioButtonChange}
                />
            </Form.Group>
            <Form.Group>
                <div><Form.Label>Type</Form.Label></div>
                <Form.Check
                    inline
                    id="typeInternalRadioOption"
                    type="radio"
                    name="Type"
                    label="Internal"
                    value="Internal"
                    checked={tenant.Type === "Internal"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    inline
                    id="typePartnerRadioOption"
                    type="radio"
                    name="Type"
                    label="Partner"
                    value="Partner"
                    checked={tenant.Type === "Partner"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    inline
                    id="typeProspectRadioOption"
                    type="radio"
                    name="Type"
                    label="Prospect"
                    value="Prospect"
                    checked={tenant.Type === "Prospect"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    inline
                    id="typePayingCustomerRadioOption"
                    type="radio"
                    name="Type"
                    label="Paying Customer"
                    value="Paying Customer"
                    checked={tenant.Type === "Paying Customer"}
                    onChange={handleRadioButtonChange}
                />
            </Form.Group>
            <Form.Group>
                <div>
                    <Form.Label>Live</Form.Label>
                </div>
                <Form.Check
                    inline
                    id="liveYesRadioOption"
                    type="radio"
                    name="Live"
                    label="Yes"
                    value="Yes"
                    checked={tenant.Live === "Yes"}
                    onChange={handleRadioButtonChange}
                />
                <Form.Check
                    inline
                    id="liveNoRadioOption"
                    type="radio"
                    name="Live"
                    label="No"
                    value="No"
                    checked={tenant.Live === "No"}
                    onChange={handleRadioButtonChange}
                />
            </Form.Group>
            <Form.Group>
                <div>
                    <Form.Label>Business status</Form.Label>
                </div>
                <Form.Check
                inline
                    id="BusinessStatusGreenRadioOption"
                    type="radio"
                    name="BusinessStatus"
                    label="Green"
                    value="Green"
                    checked={tenant.BusinessStatus === "Green"}
                    onChange={handleRadioButtonChange}
                />                
                <Form.Check
                inline
                    id="BusinessStatusYellowRadioOption"
                    type="radio"
                    name="BusinessStatus"
                    label="Yellow"
                    value="Yellow"
                    checked={tenant.BusinessStatus === "Yellow"}
                    onChange={handleRadioButtonChange}
                />                
                <Form.Check
                inline
                    id="BusinessStatusRedRadioOption"
                    type="radio"
                    name="BusinessStatus"
                    label="Red"
                    value="Red"
                    checked={tenant.BusinessStatus === "Red"}
                    onChange={handleRadioButtonChange}
                />     
                <Form.Check
                    inline
                    id="BusinessStatusShutDownRadioOption"
                    type="radio"
                    name="BusinessStatus"
                    label="Shut Down"
                    value="Shut Down"
                    checked={tenant.BusinessStatus === "Shut Down"}
                    onChange={handleRadioButtonChange}
                />                
            </Form.Group>
            <Form.Group>
                <Form.Label>Business comment</Form.Label>
                <Form.Control type="text" placeholder="Enter business comment" name="BusinessComment" value={tenant.BusinessComment} onChange={handleChange} />
            </Form.Group>
            <Form.Group>
                <Form.Label>Primary contact</Form.Label>
                <Form.Control as="select" name="PrimaryContact" value={tenant.PrimaryContact} onChange={handleChange}>
                    <option value={""}>Pick user</option>
                    {userTenantConnections && userTenantConnections.map(user => <option key={user.id} value={user.UserID}>
                        #{user.UserID} {user.UserFirstName} {user.UserLastName}
                    </option>)}
                </Form.Control>
            </Form.Group>
            <Form.Group>
                <Form.Label>Secondary contact</Form.Label>
                <Form.Control as="select" name="SecondaryContact" value={tenant.SecondaryContact} onChange={handleChange}>
                    <option value={""}>Pick user</option>
                    {userTenantConnections && userTenantConnections.map(user => <option key={user.id} value={user.UserID}>
                        #{user.UserID} {user.UserFirstName} {user.UserLastName}
                    </option>)}
                </Form.Control>
            </Form.Group>
        </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="default" onClick={onHide}>Cancel</Button>
            {!editTenant && <Button onClick={handleSave} disabled={creatingTenant}>{creatingTenant ? "Deploying.." : "Deploy"}</Button>}
            {editTenant && <Button onClick={handleSave} disabled={updatingTenant}>{updatingTenant ? "Saving.." : "Save"}</Button>}
        </Modal.Footer>
    </Modal>
}

export default AddEditTenantModal